var _style, _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyTech(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 89 89",
    style: {
      enableBackground: "new 0 0 89 89"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#FCBC00;}\n")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M68.5,20.6h-48c-3,0-5.3,2.4-5.3,5.3v32c0,2.9,2.4,5.3,5.3,5.3h13.3v5.3h21.3v-5.3h13.3c2.9,0,5.3-2.4,5.3-5.3 v-32C73.8,23,71.4,20.6,68.5,20.6z M68.5,58h-48v-32h48C68.5,25.9,68.5,58,68.5,58z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.1,
    y: 30.8,
    className: "st0",
    width: 6.5,
    height: 9.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.2,
    y: 43.4,
    className: "st0",
    width: 6.5,
    height: 9.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 43.3,
    className: "st0",
    width: 11.6,
    height: 9.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.1,
    y: 30.7,
    className: "st0",
    width: 11.6,
    height: 9.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.7,
    y: 30.7,
    className: "st1",
    width: 9.4,
    height: 21.9
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyTech);
export default __webpack_public_path__ + "static/media/my-tech.b800cc4ae43b576484db61d8c58aee93.svg";
export { ForwardRef as ReactComponent };